import React, { useEffect, useState } from 'react'
import { CUSTOMER_PATH, getCustomerById, updateCustomer } from '../../api/customerApi';
import Input from '../../components/Input';
import CurrencyPicker from '../../components/currency/CurrencyPicker';
import { CURRENCIES, VALIDATION_MESSAGE } from '../../utils/constants';
import { onChange } from '../../utils/functions';
import Textarea from '../../components/Textarea';
import Button from '../../components/Button';
import { useApiProgress } from '../../hooks/ApiProgress';
import { useParams } from 'react-router-dom';
import { useCloseTab } from '../../components/tabs/TabsContext';
import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner';

const CustomerEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const closeTab = useCloseTab()
    const [entity, setEntity] = useState({

    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${CUSTOMER_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${CUSTOMER_PATH}`, false)

    useEffect(() => {
        getCustomerById(id).then(res => setEntity(res.data))
    }, [id])

    const onClickSubmit = () => {
        updateCustomer(id, entity)
            .then(res => {
                closeTab()
                toast.success('Müşteri güncellendi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Müşteri Düzenle</label>
                <Input
                    label='Müşteri Kodu'
                    name='code'
                    placeholder='Müşteri kodu girin'
                    error={errors.code}
                    value={entity.code}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Input
                    label='Müşteri Adı'
                    name='name'
                    placeholder='Müşteri adı girin'
                    error={errors.name}
                    value={entity.name}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Input
                    label='Telefon Numarası'
                    name='phone'
                    placeholder='Telefon numarası girin'
                    error={errors.phone}
                    value={entity.phone}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <Textarea
                    label='Adres'
                    name='address'
                    placeholder='Adres girin'
                    value={entity.address}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <CurrencyPicker
                    label="Kur"
                    value={entity.currency}
                    onChange={(currency) => setEntity(prevState => ({ ...prevState, currency }))}
                    text={(entity.currency) || 'Kur seçin'}
                    items={CURRENCIES}
                    error={errors.currency}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    placeholder='Açıklama girin'
                    value={entity.description}
                    onChange={e => onChange(e, setEntity, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default CustomerEditPage